<template>
  <div>
    <el-row class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="16" :md="16">
        <el-input v-model="filtro.entidade_id" placeholder="Entidade ID (ex: 123)" @keyup.native.enter="loadingDocumentos"></el-input>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
        <el-button type="primary" @click="openDialog()">NOVO DOCUMENTO</el-button>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="u-mb-10">
      <el-col :xs="24" :sm="8" :md="8">
        <el-input v-model="filtro.entidade_tipo" placeholder="Entidade tipo (ex: cotacao, gasto...)" @keyup.native.enter="loadingDocumentos"></el-input>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8">
        <el-input v-model="filtro.tipo" placeholder="Tipo (proposta, nf, pagamento...)" @keyup.native.enter="loadingDocumentos"></el-input>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
        <el-button @click="loadingDocumentos" type="info" plain icon="el-icon-search">FILTRAR</el-button>
      </el-col>
    </el-row>

    <div class="container-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="hidden-mobile" style="width: 70px;">cod</th>
            <th>Arquivo</th>
            <th class="hidden-mobile">Entidade</th>
            <th class="hidden-mobile">Tipo</th>
            <th class="hidden-mobile">Caminho</th>
            <th style="width: 140px;" class="u-text-center">Ação</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="item in items" :key="item.id">
            <td class="hidden-mobile">{{ item.id }}</td>
            <td>{{ item.nome_arquivo }}</td>
            <td class="hidden-mobile">{{ item.entidade_tipo }} #{{ item.entidade_id }}</td>
            <td class="hidden-mobile">{{ item.tipo || '-' }}</td>
            <td class="hidden-mobile">{{ item.caminho }}</td>
            <td class="u-text-center acao">
              <el-button @click="deleteDocumento(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!statusList" class="u-text-center u-mt-25">
        <img src="/public/img/loading-bar.gif" />
      </div>

      <el-row :gutter="10" v-if="statusList">
        <el-col :xs="24" :sm="12" :md="12">
          <div class="u-text-left u-mt-10">
            Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
          <div class="u-text-right">
            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
              @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog append-to-body :title="'Novo Documento'" :visible.sync="dialogVisible" width="70%" top="5vh">
      <el-form :model="form" ref="form" label-position="top">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Entidade tipo" prop="entidade_tipo" :rules="[$requiredBlur]" key="entidade_tipo">
              <el-input v-model="form.entidade_tipo" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Entidade ID" prop="entidade_id" :rules="[$requiredBlur]" key="entidade_id">
              <el-input v-model="form.entidade_id" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Nome do arquivo" prop="nome_arquivo" :rules="[$requiredBlur]" key="nome_arquivo">
              <el-input v-model="form.nome_arquivo" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item label="Tipo" prop="tipo" key="tipo">
              <el-input v-model="form.tipo" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item label="Caminho" prop="caminho" :rules="[$requiredBlur]" key="caminho">
              <el-input v-model="form.caminho" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">CANCELAR</el-button>
        <el-button type="primary" @click="saveDocumento">SALVAR</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    statusList: false,
    filtro: {
      entidade_tipo: '',
      entidade_id: '',
      tipo: ''
    },
    paginate: {
      page: 1,
      qtdItens: null,
      from: '',
      to: ''
    },
    items: [],
    dialogVisible: false,
    form: {
      entidade_tipo: '',
      entidade_id: '',
      nome_arquivo: '',
      caminho: '',
      tipo: ''
    }
  }),
  mounted () {
    this.loadingDocumentos()
  },
  methods: {
    loadingDocumentos () {
      this.statusList = false
      this.items = []
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/documento/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.items = response.data.data
          this.paginate.qtdItens = response.data.total
          this.paginate.from = response.data.from
          this.paginate.to = response.data.to
          this.statusList = true
        }).catch((error) => { this.$store.commit('throwException', error) })
    },
    openDialog () {
      this.dialogVisible = true
      this.form = { entidade_tipo: '', entidade_id: '', nome_arquivo: '', caminho: '', tipo: '' }
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    saveDocumento () {
      this.$refs.form.validate((valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/documento/store`, this.form, this.$store.getters.getHeaderAuth).then(() => {
          window.eventBus.$emit('loading', false)
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.dialogVisible = false
          this.loadingDocumentos()
        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
      })
    },
    deleteDocumento (id) {
      this.$msgbox.confirm('Tem certeza que deseja excluir este documento?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          window.eventBus.$emit('loading', true)
          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/financeiro/documento/delete/` + id, this.$store.getters.getHeaderAuth).then(() => {
            window.eventBus.$emit('loading', false)
            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
            this.loadingDocumentos()
          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }).catch(() => { })
    },
    getPagePagination (page) {
      this.paginate.page = page
      this.loadingDocumentos()
    }
  }
}
</script>

